import Icon from '@/components/ui/AppIcon';

interface IntegrationPointProps {
  title: string;
  description: string;
  icon: string;
  phases: string[];
}

const IntegrationPoint = ({ title, description, icon, phases }: IntegrationPointProps) => {
  return (
    <div className="bg-surface border border-border rounded-lg p-6 hover:border-institutional transition-base">
      <div className="flex items-start space-x-4">
        <div className="flex items-center justify-center w-12 h-12 bg-institutional/10 rounded-lg flex-shrink-0">
          <Icon name={icon as any} size={24} variant="outline" className="text-institutional" />
        </div>
        <div className="flex-1">
          <h4 className="text-lg font-semibold text-text-primary mb-2">{title}</h4>
          <p className="text-sm text-text-secondary mb-4">{description}</p>
          <div className="flex flex-wrap gap-2">
            {phases.map((phase, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-institutional/10 text-institutional text-xs font-medium rounded-full"
              >
                {phase}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationPoint;